import { capitalize } from "lodash";

export const stringToTitleCase = (string: string): string => {
  return string
    .split(" ")
    .map((s) => capitalize(s))
    .join(" ");
};
